function get(n) {
  var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]*)(;|$)'));
  return !m ? '' : decodeURIComponent(m[2]);
}
function set(name, val, obj) {
  if (!name || typeof name != 'string' ||
    !val || typeof val != 'string') {
    return false;
  }

  var str = name + '=' + val + ';';
  if (obj && obj.expires) {
    var d = new Date();
    d.setTime(d.getTime() + (expires * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    str += expires + ';';
  }

  if (obj && obj.path) {
    str += 'path=' + obj.path + ';';
  }

  document.cookie = str;
}
function clear(name) {
  setCookie(name, '', {'expires': -1});
}
export default {
  get,
  set,
  clear,
};



// WEBPACK FOOTER //
// ./src/component/common/cookie.js